import React from 'react'
import { connect } from 'react-redux'
import { toggleNode } from '../../controllers/treeEngine'
import { moveCursorTo } from '../../store/cursor'

const nodeTypesToSymbols = {
    checkbox: <i className="fal fa-circle"></i>,
    text: <i className="fal fa-align-left"></i>,
    done: <i className="fas fa-check-circle"></i>,
    failed: <i className="fal fa-alien-monster"></i>,
    waiting: <i className="fal fa-hourglass-half"></i>,
    idea: <i className="fal fa-lightbulb"></i>,
    cancelled: <i className="fas fa-moon"></i>
}

const LabelComponent = (props) => {
    const symbol = nodeTypesToSymbols[props.type]

    const onClickLabel = () => {
        const { nodeId, moveCursorTo } = props
        toggleNode(nodeId)
        moveCursorTo(nodeId)
    }

    return (
        <div className="list-item-type" onClick={onClickLabel}>
            {symbol}
        </div>
    )
}

const mapDispatchToProps = {
    moveCursorTo
}

const mapStateToProps = (state, ownProps) => {
    return {
        type: state.nodes[ownProps.nodeId].type
    }
}

export const Label = connect(mapStateToProps, mapDispatchToProps)(LabelComponent)
